<template>  
	<v-navigation-drawer mobile-break-point="10240"	clipped fixed hide-overlay v-model="sideProps" app>    
		<v-list dense>	
			<div class="menu_holder">				
				<v-list-tile  @click="fncShowSettings()">
					<v-list-tile-action>
						<v-icon>settings</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>General Settings</v-list-tile-title>															
					</v-list-tile-content>
				</v-list-tile>							
			</div>	
			<div v-for="(item, index) in menu" class="menu_holder" :key="item.id">				
				<v-list-tile v-if="objAuthorize.privileges.indexOf(item.priv) !== -1 || item.priv === 'All'"  @click="showNavChildren(item.id, item.link, index)">
					<v-list-tile-action>
						<v-icon :style="{ color: item.color }">{{ item.icon }}</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>{{ item.title }}</v-list-tile-title>															
					</v-list-tile-content>
				</v-list-tile>
				<v-list-tile class="navChild" v-if="clickStatus[index][item.id] && objAuthorize.privileges.indexOf(subItem.priv) !== -1 || subItem.priv === 'All'" v-for="(subItem, subIndex) in item.children" :key="subItem.id">
					<v-list-tile-content>            
						<v-list-tile-title class="cursor" @click="fncGoPage(subItem.link)"><span :style="{ background: item.color }" class="subIcon">{{ showFirstLetter(subItem.title) }}</span>{{ fncSubMenuTitle(subItem.title) }}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>							
			</div>
          <div class="menu_holder">
            <v-list-tile @click="fncClearStorage()">
              <v-list-tile-action>
                <v-icon>filter_list</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Clear All Filters</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </div>
		</v-list>
	</v-navigation-drawer>
</template>

<script>
	import menu from '@/menu';
	import Vue from 'vue';
	import router from '@/router';
	import { mapGetters } from 'vuex'; 
	import Modal from './modal';
	
	export default {
	  name: 'Sidebar',
	  data () {
			return {
				drawer: null,
				menu: menu,
				clickStatus: []
			};
		},
		methods: {
			showNavChildren(itemId, itemLink, index) {		
				if( itemLink !== '#' ) {
					router.replace(itemLink);
				} else {
					for( let i = 0; i < this.clickStatus.length; i++ ) {
						for( let prop in this.clickStatus[i] ) {						
							Vue.set( this.clickStatus[i], prop, false );
						}				
					}		
					Vue.set( this.clickStatus[index], itemId, true );				
				}				
			},
			showFirstLetter(title){
				return title.charAt(0);
			},
			fncGoPage(routerLink) {
              router.replace(routerLink);
              this.$store.commit('toggleDrawer', false);
			},
			fncShowSettings () {			
				var modalDetails = { title: 'General Settings', component: 'modal-general-settings', mstate: true };
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
            },
            fncClearStorage() {
              localStorage.clear();
              window.localStorage.clear();
              var snackDetails = { color: 'success', message: 'All filters have been cleared', display: true };
              this.$store.commit('setSnack', snackDetails);              
            },
            fncSubMenuTitle(menuTitle) {
              console.log( menuTitle );
              /*switch (menuTitle) {
                case '[REPS]':
                  return 'repstuff';
                default:
                  return menuTitle;
              }*/
              return 'test';
            }
		},		
		created() {
			for( let i = 0; i < menu.length; i++ ) {				
				var sub_item = { [menu[i].id]: false }
				this.clickStatus.push( sub_item );				
			}			
		},
		computed: {
			...mapGetters([			
            'objAuthorize',
            'sideProps'
				])
		}/*,
		props: ['sideProps']*/
	  }
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
